import { authenticatedFetch } from "./http";

export interface ExpiryRisk {
  itemId: string; itemCode: string; itemName: string;
  warehouseId: string; warehouseCode: string;
  clientId: string | null; clientCode: string | null;
  inventoryUnitId: string; handlingUnitNumber: string; lotNumber: string | null;
  expirationDate: string | null; daysRemaining: number | null;
  minimumRemainingShelfLifeDays: number;
  onHandQuantity: number; allocatedQuantity: number; quantityAtRisk: number;
  uom: string; risk: "DATA_ERROR" | "EXPIRED" | "SHELF_POLICY" | "CRITICAL" | "WARNING";
  recommendedAction: string;
  shelfLifeDerogationPending: boolean;
  shelfLifeDerogationNumber: string | null;
  shelfLifeDerogationWorkflowState: "INTERNAL_REVIEW" | "PARTNER_REVIEW" | "PENDING_EXECUTION" | "COMPLETED" | "CANCELLED" | null;
  outsideSelectedHorizon: boolean;
}

export interface FefoException {
  id: string; itemId: string; itemCode: string; itemName: string;
  warehouseId: string; warehouseCode: string; inventoryUnitId: string | null;
  handlingUnitNumber: string | null; lotNumber: string | null;
  preparationTaskId: string | null; exceptionType: string; severity: string;
  status: string; requiredOn: string | null; expirationDate: string | null;
  requiredRemainingDays: number | null; actualRemainingDays: number | null;
  expectedHandlingUnitNumber: string | null; expectedLotNumber: string | null;
  expectedExpirationDate: string | null; expectedAvailableQuantity: number | null;
  expectedUom: string | null;
  reason: string; requestReason: string | null; resolution: string | null;
  detectedAt: string; version: number;
}

export interface FefoTraceEvent {
  occurredAt: string; eventType: string; reference: string; detail: string;
}

export type ExpiryDispositionAction = "QUALITY_DEROGATION" | "QUARANTINE";

export interface ExpiryDispositionResult {
  action: ExpiryDispositionAction;
  status: string;
  qualityInspectionId: string | null;
}

export const loadExpiryRisks = (horizonDays: number) =>
  authenticatedFetch<ExpiryRisk[]>(`/api/v1/fefo/risks?horizonDays=${horizonDays}`);
export const loadFefoExceptions = () =>
  authenticatedFetch<FefoException[]>("/api/v1/fefo/exceptions");
export const loadFefoTrace = (inventoryUnitId: string) =>
  authenticatedFetch<FefoTraceEvent[]>(`/api/v1/fefo/trace/inventory-units/${inventoryUnitId}`);
export const decideFefoException = (id: string, decision: "APPROVED" | "REJECTED", reason: string, version: number) =>
  authenticatedFetch<FefoException>(`/api/v1/fefo/exceptions/${id}/decision`, {
    method: "POST", body: JSON.stringify({ decision, reason, version })
  });
export const requestFefoException = (taskId: string, reason: string) =>
  authenticatedFetch<FefoException>(`/api/v1/fefo/exceptions/tasks/${taskId}/request`, {
    method: "POST", body: JSON.stringify({ reason })
  });
export const submitExpiryDisposition = (inventoryUnitId: string, action: ExpiryDispositionAction, extensionDays?: number) =>
  authenticatedFetch<ExpiryDispositionResult>(`/api/v1/fefo/risks/inventory-units/${inventoryUnitId}/disposition`, {
    method: "POST", body: JSON.stringify({ action, extensionDays: action === "QUALITY_DEROGATION" ? extensionDays : null })
  });
